<template>
  <v-main>
    <v-container fluid grid-list-xs pt-5>
      <v-layout row wrap justify-center align-center>
        <v-flex xs11 lg11>
          <h2>
            <v-icon color="#077893" @click="Fn_BackIndex" size="38"
              >mdi-chevron-left</v-icon
            >{{ $t("Template.update") }}
          </h2>
        </v-flex>
      </v-layout>
      <v-layout row wrap justify-center align-center pa-1>
        <v-flex xs11 lg11>
          <v-form ref="form" v-model="valid">
            <v-card class="rounded-lg">
              <v-card-title primary-title>
                {{ $t("Template.template_data") }}
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text class="pt-5">
                <v-layout row wrap justify-center align-center pa-1>
                  <v-flex xs11 sm11 md11 lg11 pa-1>
                    <b>ชื่อเทมเพลท (ฺTemplate Name) <span style="color: red;">*</span></b>
                    <v-text-field
                      outlined
                      dense
                      color="#077893"
                      v-model="Name"
                      maxlength="200"
                      :rules="[(v) => !!v || 'กรุณากรอกข้อมูลให้ครบถ้วน']"
                      prepend-inner-icon="mdi-account-outline"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row wrap justify-center align-center pa-1>
                  <v-flex xs11 sm11 md11 lg11 pa-1>
                    <b>หัวข้อ</b>
                    <v-text-field
                      hide-details
                      outlined
                      dense
                      color="#077893"
                      v-model="Title"
                      maxlength="200"
                      prepend-inner-icon="mdi-account-outline"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row wrap justify-center align-center pa-1>
                  <v-flex xs11 sm11 md11 lg11 pa-1>
                    <!-- <p>{{typeof radioCheckNoti || 'null' }}</p> -->
                    <b>การแจ้งเตือน <span style="color: red;">*</span></b>
                    <v-text-field
                      hide-details
                      outlined
                      dense
                      color="#077893"
                      maxlength="200"
                      :rules="[(v) => !!v || 'กรุณากรอกข้อมูลให้ครบถ้วน']"
                      v-model="CustomNotification"
                      prepend-inner-icon="mdi-account-outline"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row wrap justify-center align-center pa-1>
                  <v-flex xs11 sm11 md11 lg11 pa-1>
                    <b>รายละเอียด</b>
                    <v-text-field
                      outlined
                      dense
                      color="#077893"
                      v-model="Details"
                      maxlength="1000"
                      counter
                      prepend-inner-icon="mdi-account-outline"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <!-- <v-layout row wrap justify-center align-center pa-1>
                  <v-flex xs11 sm11 md11 lg11 pa-1>
                    <b>Account id</b>
                    <v-text-field
                      hide-details
                      outlined
                      dense
                      color="#077893"
                      v-model="AccountId"
                      prepend-inner-icon="mdi-account-outline"
                    ></v-text-field>
                  </v-flex>
                </v-layout> -->
                <!-- <v-layout row wrap justify-center align-center pa-1>
                  <v-flex xs11 sm11 md11 lg11 pa-1>
                    <b>Business ID</b>
                    <v-text-field
                      hide-details
                      outlined
                      dense
                      color="#077893"
                      v-model="BusinessId"
                      prepend-inner-icon="mdi-account-outline"
                      :rules="[
                        (v) => !!(v && v.trim()) || 'กรุณากรอกข้อมูลให้ครบถ้วน',
                      ]"
                    ></v-text-field>
                  </v-flex>
                </v-layout> -->
                <v-layout row wrap justify-center align-center pa-1>
                  <v-flex xs11 lg11>
                    <b>รูปภาพ</b>
                    <v-card outlined>
                      <v-card-text>
                        <v-flex xs11 sm11 md11 lg11 pa-1>
                          <div>
                            <v-file-input
                              v-model="selectedFile"
                              accept=".png"
                              truncate-length="50"
                              label="อัปโหลดรูปภาพ"
                              @change="onFileChange"
                            ></v-file-input>

                            <!-- แสดงรูปภาพที่เลือก -->
                            <v-card
                              v-if="imagePreview"
                              class="mt-4 pa-3"
                              max-width="300"
                            >
                              <v-img
                                :src="imagePreview"
                                :alt="'bot-template-image.png'"
                                contain
                              ></v-img>
                            </v-card>
                          </div>
                        </v-flex>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-card-text>
              <v-card-actions>
                <v-layout row wrap justify-center align-center pb-5>
                  <v-flex xs10 md3 lg3>
                    <v-btn
                      block
                      dark
                      color="#077893"
                      :loading="LoadingSave"
                      @click="Fn_UpdateTemplate"
                      >{{ $t("policyForm.save") }}</v-btn
                    >
                  </v-flex>
                </v-layout>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-flex>
      </v-layout>
    </v-container>
  </v-main>
</template>

<script>
import authorization from "@/functions/authorization.js";
import Swal2 from "sweetalert2/dist/sweetalert2.js";
import { mapGetters } from "vuex";
const Toast = Swal2.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});
export default {
  components: {},
  data: () => {
    return {
      selectedFile: null,
      imagePreview: null,
      imagePreviewOld: null,
      BotName: "",
      Name: "",
      BusinessId: "",
      Title: "",
      Bot_ID: "",
      Details: "",
      CustomNotification: "",
      Token_Bot: "",
      AccountId: "",
      valid: true,
      isChanagedImage: false,
      LoadingSave: false,
      SenderDisplayName: "",
      RuleEmailAddress: [
        (v) => !!v || "กรุณากรอกอีเมลแอดเดรสผู้ส่ง",
        (v) => /.+@.+\..+/.test(v) || "รูปแบบอีเมลไม่ถูกต้อง",
      ],
      RuleBotName: [(v) => !!(v && v.trim()) || "กรุณากรอกชื่อบอท"],
    };
  },
  computed: {
    ...mapGetters(["DataUpdateBot"]),
    _BotTemplateAll: {
      get() {
        return this.DataUpdateBot || "-";
      },
    },
  },
  mounted() {
    this.getImageSrc(this._BotTemplateAll.Image); // ใช้ข้อมูลจาก props หรือ computed property
    this.Fn_GetTemplateDetail();
    this.Fn_GetOneData();
  },
  methods: {
    Fn_GetOneData() {
      this.AccountId = this.$cookies.get("OneAccountId");
      this.BusinessId = this.$cookies.get("BusinessId");
    },
    Fn_GetTemplateDetail() {
      this.Name = this._BotTemplateAll.Name;
      this.Title = this._BotTemplateAll.Title;
      this.Details = this._BotTemplateAll.Details;
      this.CustomNotification = this._BotTemplateAll.CustomNotification;
    },
    getImageSrc(base64Data) {
      if (base64Data.startsWith("data:image")) {
        this.imagePreview = base64Data; // ถ้าเป็น base64 ที่ถูกต้องแล้ว
        this.imagePreviewOld = base64Data;
      } else {
        this.imagePreview = `data:image/jpeg;base64,${base64Data}`;
        this.imagePreviewOld = `data:image/jpeg;base64,${base64Data}`;
      }
    },
    Fn_BackIndex() {
      this.$router.push("/template-bot");
    },
    async Fn_UpdateTemplate() {
      const isValid = this.$refs.form.validate();
      if (isValid) {
        const formData = new FormData();
        formData.append("Name", this.Name);
        formData.append("BusinessId", this.BusinessId);
        formData.append("AccountId", this.AccountId);
        formData.append("Details", this.Details);
        formData.append("Title", this.Title);
        formData.append("CustomNotification", this.CustomNotification);
        if (this.isChanagedImage) {
          formData.append("Image", this.selectedFile); // ไฟล์แนบ
        }
        var Headers = {
          AccountId: this.$cookies.get("OneAccountId"),
        };
        var auth = await authorization.encodeDataNew(Headers);
        var headers = {
          Authorization: "Bearer " + auth,
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "multipart/form-data",
          "ngrok-skip-browser-warning": "true",
        };
        this.axios
          .put(
            process.env.VUE_APP_API_FACTORING_SERVICE +
              `onechat/Template/${this._BotTemplateAll.Id}`,
            formData,
            {
              headers,
            }
          )
          .then((response) => {
            Toast.fire({
              icon: "success",
              title: this.$i18n.t("Template.edited"),
            });
            this.$router.push("/template-bot");
            // this.tableload = false;
          })
          .catch((error) => {
            if (error.response) {
              Toast.fire({
                icon: "error",
                title: error.response.data.ErrorMessage,
              });
            } else if (error.request) {
              Toast.fire({
                icon: "error",
                title: error.request,
              });
            } else {
              Toast.fire({
                icon: "error",
                title: error.message || error,
              });
            }
          });
      }
    },
    onFileChange(file) {
      this.isChanagedImage = true;
      if (file) {
        this.imagePreview = URL.createObjectURL(file); // สร้าง URL สำหรับ preview
      } else {
        this.imagePreview = null; // รีเซ็ตถ้าไม่มีไฟล์
        this.imagePreview = this.imagePreviewOld;
      }
    },
  },
  watch: {},
};
</script>

<style></style>
